var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3666 9.84172C22.941 9.41589 22.4356 9.0781 21.8794 8.84763C21.3232 8.61716 20.727 8.49854 20.1249 8.49854C19.5229 8.49854 18.9267 8.61716 18.3705 8.84763C17.8143 9.0781 17.3089 9.41589 16.8833 9.84172L15.9999 10.7251L15.1166 9.84172C14.2569 8.98198 13.0908 8.49898 11.8749 8.49898C10.6591 8.49898 9.49301 8.98198 8.63327 9.84172C7.77353 10.7015 7.29053 11.8675 7.29053 13.0834C7.29053 14.2993 7.77353 15.4653 8.63327 16.3251L9.5166 17.2084L15.9999 23.6917L22.4833 17.2084L23.3666 16.3251C23.7924 15.8994 24.1302 15.3941 24.3607 14.8379C24.5912 14.2816 24.7098 13.6855 24.7098 13.0834C24.7098 12.4813 24.5912 11.8851 24.3607 11.3289C24.1302 10.7727 23.7924 10.2674 23.3666 9.84172V9.84172Z",
    stroke: "#9F9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.cfe14df172d46b295481933b97dc88a0.svg";
export { ForwardRef as ReactComponent };